import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-delete-check-modal',
  templateUrl: './delete-check-modal.component.html',
  styleUrls: ['./delete-check-modal.component.scss'],
  imports: [TranslatePipe, NgbTooltip]
})
export class DeleteCheckModalComponent implements OnInit {
  public entity: string;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}
}
